module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_3.10401485.png";